import { VenueBlockUserInput } from '../../graphql/API';
import { venueUnblockUser } from '../../graphql/mutations';
import { executeGql } from '../../utils/gql-utils';

export const venueUnblockUserApi = async (input: VenueBlockUserInput): Promise<void> => {
  await executeGql(venueUnblockUser, { input });
};
